import {Component, Inject, OnInit, PLATFORM_ID} from '@angular/core';
import {HeaderComponent} from "../../components/header/header.component";
import {TranslocoPipe, TranslocoService} from '@jsverse/transloco';
import {BookingService} from '../../services/booking/booking.service';
import {Booking} from '../../../core/entities/booking/booking.entity';
import {ActivatedRoute, RouterLink} from '@angular/router';

import {CarouselComponent} from '../../../core/components/carousel/carousel.component';
import {ToastrService} from 'ngx-toastr';
import {isPlatformBrowser} from '@angular/common';
import {AppImageComponent} from '../../../core/components/image/image';

@Component({
  selector: 'app-booking-photos',
  imports: [
    HeaderComponent,
    TranslocoPipe,
    CarouselComponent,
    RouterLink,
    AppImageComponent,
  ],
  templateUrl: './booking-photos.component.html',
  styleUrl: './booking-photos.component.scss'
})
export class BookingPhotosComponent implements OnInit {
  public booking: Booking|null = null;
  public isCarouselOpen = false;
  public carouselIndex = 0;
  public isDownloading = false;

  public constructor(
    private readonly bookingService: BookingService,
    private readonly activatedRoute: ActivatedRoute,
    private readonly toastr: ToastrService,
    private readonly transloco: TranslocoService,
    @Inject(PLATFORM_ID) private platformId: Object,
  ) {
  }

  public ngOnInit() {
    const bookingIdParam = this.activatedRoute.snapshot.paramMap.get('id');
    if (!bookingIdParam) {
      return;
    }
    const bookingId = parseInt(bookingIdParam);
    this.bookingService.getBooking(bookingId).subscribe(
      (booking) => {
        this.booking = booking;
      }
    )
  }

  public downloadPhotos(): void {
    if (!this.booking || !isPlatformBrowser(this.platformId)) {
      return;
    }

    this.isDownloading = true;
    const bookingId = this.booking.id;

    this.toastr.info(
      this.transloco.translate('bookings.photos.toast.download-started.content'),
      this.transloco.translate('bookings.photos.toast.download-started.title'),
    );

    this.bookingService.downloadBookingPhotosAsBlob(bookingId).subscribe({
      next: (blob: Blob) => {
        const url = window.URL.createObjectURL(blob);
        const a = document.createElement('a');
        a.href = url;
        a.download = `shutterflow_booking_${bookingId}.zip`;
        document.body.appendChild(a);
        a.click();
        document.body.removeChild(a);
        window.URL.revokeObjectURL(url);
        this.isDownloading = false;

        this.toastr.success(
          this.transloco.translate('bookings.photos.toast.download-success.content'),
          this.transloco.translate('bookings.photos.toast.download-success.title'),
        );
      },
      error: () => {
        this.isDownloading = false;

        this.toastr.error(
          this.transloco.translate('bookings.photos.toast.download-error.content'),
          this.transloco.translate('bookings.photos.toast.download-error.title'),
        );
      }
    });
  }

  public openCarousel(index: number) {
    this.carouselIndex = index;
    this.isCarouselOpen = true;
  }

  public closeCarousel() {
    this.isCarouselOpen = false;
  }
}
